import { handleNext } from '../../components/ProgressiveFormStepper/utils';
import { getToday, getUsefulVars } from '../../handlers/helpers';
import { updateSectionData } from '../../handlers/utils';
import { runAxios } from '../../handlers/axios';
import { onLink, onSubmit, save, unloadCallback } from '../../handlers';
import axios from 'axios';
import { Box, Image } from '@chakra-ui/react';
import React from 'react';

export const handleTestComplete = (results) => {

  //alert(results);
  //console.log('Holland Code:', results.hollandCode); // e.g., "RIA"
  //console.log('All Scores:', results.scores); // e.g., {R: 15, I: 12, A: 10, ...}
  //console.log('Top Types:', results.topTypes); // Top 3 types with scores
  //props.stateProps.dataToSave.saved.resumes[props.stateProps.sectionData.resumeIndex]['new-aptitude'][0]['aptitude_results'][test] = results;
  // Do something with the results:
  // - Save to database
  // - Navigate to next page
  // - Store in state
  // - Show career recommendations
};

export const download = async (uv,aptitudeResults) => {
  uv.stateProps.setSpinnerMessage('Message: Prepare to find career direction - without needing GPS!');
  uv.stateProps.setSpinnerImage('downloadAptitude.gif');
  uv.stateProps.onSpinnerOpen();
  window.removeEventListener('beforeunload', unloadCallback);
  onSubmit(uv.formikProps, uv.stateProps);
  const url = uv.stateProps.domain + '/wp-json/rsworks/v1/downloadAptitudeResults';

  const firstName = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['contact'][0]['first'];
  const lastName = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['contact'][0]['last'];
  const request = {
    results: aptitudeResults,
    date: getToday(),
    title: 'Aptitude Results',
    first_name:firstName,
    last_name: lastName,
  };
  const result = await axios.post(url, request);

  let link = document.createElement('a');
  link.href = result.data;
  link.download = 'file.pdf';
  link.dispatchEvent(new MouseEvent('click'));
  window.addEventListener('beforeunload', unloadCallback);
  uv.stateProps.setMessageModal(true);
  updateSectionData({
    modalMessage: 'You\'ve downloaded your results! Check your download bar in your browser or downloads folder to view them.',
    fileUrl: result.data,
  }, uv.stateProps);
  uv.stateProps.setSpinnerImage('preview.gif');
  uv.stateProps.setSpinnerMessage('Wishing you an inbox full of amazing job offers!');
  uv.stateProps.onSpinnerClose();

  uv.stateProps.onOpen();
}
export const saveTest=(e,props) => {
  e.preventDefault();
  const uv = getUsefulVars(props);
  if(uv.formikProps.values) {
    const jobSeekerData = uv.formikProps.values.jobSeekerData[0];
    jobSeekerData[e.id] = e.currentTarget.value;
  }
//  alert(e.currentTarget.value);

}
export const editResults = (props) => {
  if(window.confirm('Are you sure you want to delete your existing results?')) {
    const uv = getUsefulVars(props)
    uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['new-aptitude'][0]['aptitude_results'] = '';
    const sectionName = uv.stateProps.sectionData.sectionName;
    onSubmit(uv.formikProps, uv.stateProps, sectionName);
    onLink(false, uv.formikProps, uv.stateProps, 'new-aptitude', 0);
  }
}
const stripBackslashesAndNewlines = (str) => {
  return str.replace(/\\n/g, '').replace(/\\/g, '');
}
export const handleAptitudeNext =(props,groupedQuestions,step,secOrIndIndex) => {
  handleNext(props, groupedQuestions, step, secOrIndIndex)
}

const handleAptitudeResultsCallback = (result,args) => {
  const stateProps = args.props.stateProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const sectionName = stateProps.sectionData.sectionName;
  const section = stateProps.dataToSave.saved.resumes[resumeIndex][sectionName];
  if(section === undefined) {
    stateProps.dataToSave.saved.resumes[resumeIndex][sectionName] = [];
    stateProps.dataToSave.saved.resumes[resumeIndex][sectionName][0] = {};
    stateProps.dataToSave.saved.resumes[resumeIndex][sectionName][0]['IY1'] = '';
  }
  stateProps.dataToSave.saved.resumes[resumeIndex][sectionName][0]['aptitude_results'] = result.data.interview;
   args.aptitudeResults['aptitude_results'] = result.data.assessments;
  save(stateProps, resumeIndex);
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
  handleNext(args.props, args.groupedQuestions, 0, args.secOrIndIndex)
}
export const handleAptitudeResults = (props, groupedQuestions, step, secOrIndIndex) => {
  const uv = getUsefulVars(props);
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const hollandCode = jobSeekerData[0]['holland_code'];
  const photo_career_quiz = jobSeekerData[0]['photo_career_quiz'];
  const myers_briggs = jobSeekerData[0]['myers_briggs'];
  const values_assessment = jobSeekerData[0]['values_assessment'];
  const disc_inventory = jobSeekerData[0]['disc_inventory'];
  const education_level = jobSeekerData[0]['education_level'];
  const salary_range = jobSeekerData[0]['salary_range'];

  const url = uv.stateProps.domain + '/wp-json/rsworks/v1/get_aptitude_results';
  const request = {
    holland_code: hollandCode,
    photo_career_quiz: photo_career_quiz,
    myers_briggs: myers_briggs,
    values_assessment: values_assessment,
    disc_inventory: disc_inventory,
    education_level: education_level,
    salary_range: salary_range,
  };
  const args = {
    props:props,
    groupedQuestions:groupedQuestions,
    step:step,
    secOrIndIndex:secOrIndIndex,
    aptitudeResults: jobSeekerData[0]
  }

  uv.stateProps.setSpinnerMessage('Prepare to find career direction - without needing GPS!\n' );
  uv.stateProps.setSpinnerImage('playArrow.gif');
  uv.stateProps.onSpinnerOpen();

  runAxios(url,request,handleAptitudeResultsCallback,args);

}